import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
// 三端内部组件引用到最小层级！！
import ShareComment from 'ThreeTerminal_mobile/comment/shareComment';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { ListStore } from '../../store';

// class HotComment extends React.PureComponent {
//     static propTypes = {
//         content: PropTypes.object,
//     };
//     constructor(props) {
//         super(props);
//         this.state = {};
//     }

//     render() {
//         const { content } = this.props;
//         const {
//             content: { dramaSeries, currentVideo },
//         } = content;

//         console.log('dramaSeries', dramaSeries);

//         const commentInfo1 = {
//             id: location.href, // 文章的id(同时为跳转URL！！！)
//             callType: 'web', // 文章的类型：'doc'
//             docUrl: dramaSeries.commentUrl, // 文章单页的页面地址:ucms_${content.base62Id}
//             docTitle: dramaSeries.title, // 文章的标题
//             skey: dramaSeries.skey, // 文章评论的skey，这个是在后端生成好后给到前端的
//             speUrl: '', // 兼容以后的专题评论
//             pcUrl: '', // 文章pc的页面地址
//             cmtNumUrl: `https://${ commentDomain }/get.php`, // 获取评论内容接口
//             cmtLength: 1000, // 评论内容字数长度
//             cmtPostUrl: `https://${ commentDomain }/post.php`, // 提交评论内容接口
//             hotLimit: 3, // 最热评论数量
//             limitHeight: '', // 评论区域的高度限制
//             cmtVoteUrl: `https://${ commentDomain }/vote.php`, // 推荐评论接口
//             replyLimit: 1, // 显示回复的楼层
//             jubUrl: `https://${ commentDomain }/report`, // 举报提交接口
//             jubNum: 0, // 举报次数，便于每次回调函数名不同
//             isComment: false, // 是否是评论详情页面
//             kind: 'share01', // 拉起kind值
//             clickCount: {
//                 behavior: 'action',
//                 type: 'comtmore',
//                 other: {
//                     rel: dramaSeries.commentUrl, // 文章数量：ucms_${content.base62Id}
//                     kind: 'article',
//                 },
//             },
//             downloads: {
//                 download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725251042',
//                 downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7641',
//             },
//         };
//
//         return (
//             <section className={styles.commentBox}>
//                 <ShareComment articleInfo={commentInfo} />
//             </section>
//         );
//     }
// }

const HotComment = ({ content }) => {
    // 列表数据源
    const useListStore = ListStore.useContainer();
    const { listStates, changeListStates } = useListStore;
    const { currentVideo } = listStates;
    const commentDomain = typeof window === 'object' && window.allData?.__cd__ ? window.allData.__cd__ : 'c01049em.ifeng.com';
    const commentInfo = {
        callType: 'web', // 类型:web/video
        clickCount: {
            behavior: 'action',
            type: 'comtmore',
            other: {
                kind: 'article',
                rel: currentVideo?.commentUrl, // 'ucms_8EiVMbiuE8C'
            },
        },
        cmtLength: 1000,
        cmtNumUrl: `https://${ commentDomain }/get.php`,
        cmtPostUrl: `https://${ commentDomain }/post.php`,
        cmtVoteUrl: `https://${ commentDomain }/vote.php`,
        docTitle: undefined,
        docUrl: currentVideo?.commentUrl, // 'ucms_8EiVMbiuE8C'
        downloads: {
            download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725251042',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7641',
        },
        hotLimit: 3,
        id: location.href, // id:8EiVMbiuE8C/location.href (也可以为跳转URL！！！)
        isComment: false,
        isVideoShare: undefined,
        jubNum: 0,
        jubUrl: `https://${ commentDomain }/report`,
        kind: 'share01',
        limitHeight: '',
        pcUrl: `https://v.ifeng.com/c/${currentVideo?.base62Id}`,
        replyLimit: 3,
        skey: currentVideo?.skey,
        speUrl: '',
        wxLaunchSwitch: true,
        wxLaunchType: 'app',
    };

    return (
        <section className={styles.commentBox}>
            <ShareComment articleInfo={commentInfo} />
        </section>
    );
};

HotComment.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(HotComment);
